import React, { useEffect, useState } from "react";
import "./ownAgentCalling.scss";
// images
import muteFill from "../../../assets/icons/muteFill.svg";
import microphone from "../../../assets/icons/microphone.svg";
import dialerPhone from "../../../assets/icons/dialerPhone.svg";
import aiBotPic from "../../../assets/icons/aiBotPic.png"
import callingAIIcon from "../../../assets/icons/callingAIIcon.svg";
import personCalling from "../../../assets/icons/personCalling.svg";
import { Link } from "react-router-dom";

const OwnAgentCalling = () => {
  return (
    <>
      <div className="dialerCalling-main-container">
        <div className="dialerCalling-header">
          <h2>Group Landev AI BOT</h2>
          <span></span>
        </div>
        <div className="dialerCalling-center">
          <div className="main-div">
            <img src={aiBotPic} alt="..." />
            <div id="bars">
              <div class="bar"></div>
              <div class="bar"></div>
              <div class="bar"></div>
              <div class="bar"></div>
              <div class="bar"></div>
            </div>
          </div>
        </div>
        <div className="dialerCalling-bottom">
          <div className="dailerCalling-bottom-options">
            <div>
              <img src={muteFill} alt="" />
            </div>
            <div>
              <img src={microphone} alt="" />
            </div>
            <div>
              <Link to='/dashboard'> <img src={dialerPhone} alt="" /></Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OwnAgentCalling;
